<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/news' }">
        <app-i18n code="entities.news.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.news.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.news.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-news-view-toolbar v-if="record"></app-news-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.title.label" :value="presenter(record, 'title')"></app-view-item-text>

        <app-view-item-text :label="fields.subtitle.label" :value="presenter(record, 'subtitle')"></app-view-item-text>

        <app-view-item-text :label="fields.contentHtml.label" :value="presenter(record, 'contentHtml')"></app-view-item-text>

        <app-view-item-text :label="fields.description.label" :value="presenter(record, 'description')"></app-view-item-text>

        <app-view-item-text :label="fields.sourceUrl.label" :value="presenter(record, 'sourceUrl')"></app-view-item-text>

        <app-view-item-file :label="fields.media.label" :value="presenter(record, 'media')"></app-view-item-file>

        <app-view-item-text :label="fields.status.label" :value="presenter(record, 'status')"></app-view-item-text>

        <app-view-item-relation-to-one
          :label="fields.propertyOwner.label"
          :permission="fields.propertyOwner.readPermission"
          :url="fields.propertyOwner.viewUrl"
          :value="presenter(record, 'propertyOwner')"
        ></app-view-item-relation-to-one>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NewsViewToolbar from '@modules/news/components/news-view-toolbar.vue';
import { NewsModel } from '@modules/news/news-model';

const { fields } = NewsModel;

export default {
  name: 'app-news-view-page',

  props: ['id'],

  components: {
    [NewsViewToolbar.name]: NewsViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'news/view/record',
      loading: 'news/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'news/view/doFind',
    }),

    presenter(record, fieldName) {
      return NewsModel.presenter(record, fieldName);
    },
  },
};
</script>
